import * as yup from 'yup';

const MB = 1024 * 1024;

const MAX_VIDEO_SIZE = 55 * MB;
export const ACCEPTED_VIDEO_TYPES = ['video/mp4', 'video/quicktime'];

const MAX_IMAGE_SIZE = 10 * MB;
export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];

const isFile = (value: unknown): value is File => {
  return value instanceof File;
};

export const videoSchema = yup
  .mixed<File>()
  .test('mimetype', 'INVALID_FORMAT', value => {
    return isFile(value) ? ACCEPTED_VIDEO_TYPES.includes(value.type) : true;
  })
  .test('size', 'INVALID_SIZE', value => {
    return isFile(value) ? value.size <= MAX_VIDEO_SIZE : true;
  })
  // .test('duration', 'INVALID_DURATION', (file) => {
  //   if (!file) return true;

  //   return new Promise((resolve) => {
  //     try {
  //       const url = URL.createObjectURL(file);
  //       const video = document.createElement('video');
  //       video.preload = 'metadata';
  //       video.onloadedmetadata = () => {
  //         URL.revokeObjectURL(url);
  //         resolve(video.duration <= 60);
  //       };
  //       video.onerror = () => resolve(false);
  //       video.src = url;
  //     } catch (err) {
  //       resolve(false);
  //     }
  //   });
  // })
  .optional();

export const imageSchema = yup
  .mixed<File>()
  .test('mimetype', 'INVALID_FORMAT', value => {
    return isFile(value) ? ACCEPTED_IMAGE_TYPES.includes(value.type) : true;
  })
  .test('size', 'INVALID_SIZE', value => {
    return isFile(value) ? value.size <= MAX_IMAGE_SIZE : true;
  })
  .optional();

export const _validateVideo = async (file: File) => {
  try {
    await videoSchema.validate(file, { abortEarly: false });
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      // array of errors: ['INVALID_FORMAT']
      return err.errors;
    }
  }
};

export const _validateImage = async (file: File) => {
  try {
    await imageSchema.validate(file, { abortEarly: false });
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      // array of errors: ['INVALID_FORMAT']
      return err.errors;
    }
  }
};
